<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer>
			<template #default>
				<div ref="logistictrace_custom_form"></div>
				<vxe-grid ref="list" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
				<hitchhiking-form ref="hitchhikingForm" />	
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
		
	</div>
</template>
<style scoped>

</style>
<script>
	// const formjson = {
	// 	title: '表单',
	// 	rule: {
	// 		"width": "800",
	// 		"height": "600",
	// 		"fApi": [],
	// 		"rule": [
	// 			{
	// 				"type": "$input",
	// 				"field": "input",
	// 				"title": "input",
	// 				"value": null,
	// 				"hidden": false,
	// 				"props": {
	// 					"readonly":true
	// 				},
	// 				"validate": [{
	// 					"required": false,
	// 					"message": "必填项"
	// 				}]
	// 			},
	// 			{
	// 				"type": "$datePicker",
	// 				"field": "time",
	// 				"title": "time",
	// 				"props": {
	// 					"type": "date",
	// 					"disabled":true
	// 				},
	// 				"value": null,
	// 				"hidden": false,
	// 				"validate": [{
	// 					"required": false,
	// 					"message": "必填项"
	// 				}]
	// 			},
	// 			{
	// 				"type": "$emun",
	// 				"field": "emun",
	// 				"title": "emun",
	// 				"value": null,
	// 				"hidden": false,
	// 				"props": {
	// 					"name": "enable"
	// 				},
	// 				"validate": [{
	// 					"required": false,
	// 					"message": "必填项"
	// 				}]
	// 			},
	// 			{
	// 				"type": "$upload",
	// 				"field": "upload",
	// 				"title": "upload",
	// 				"value": null,
	// 				"hidden": false,
	// 				"props": {},
	// 				"validate": [{
	// 					"required": false,
	// 					"message": "必填项"
	// 				}]
	// 			}
	// 		],
	// 		"option": {
	// 			"form": {
	// 				"labelWidth": "80px",
	// 				"hideRequiredAsterisk": false,
	// 				"showMessage": false,
	// 				"inlineMessage": false
	// 			},
	// 			"global": {
	// 				"*": {
	// 					"props": {
	// 						"el": true,
	// 						"size": "small",
	// 						"disabled": false
	// 					},
	// 					"col": {
	// 						"span": 24,
	// 						"offset": 0
	// 					}
	// 				},
	// 				"el-divider": {
	// 					"wrap": {
	// 						"show": false
	// 					},
	// 					"native": false,
	// 					"col": {
	// 						"span": 24,
	// 						"offset": 0
	// 					},
	// 					"props": {
	// 						"contentPosition": "left"
	// 					}
	// 				}
	// 			},
	// 			"submitBtn": false,
	// 			"resetBtn": false
	// 		}
	// 	}
	// }
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import hitchhikingForm from './hitchhiking.vue'
	
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_title: '采购单',
				modal_width:1000,
				modal_height:800,
				tabledata:[],
				list_footerField:[
					{field:'quantity',toFixed:0},
					{field:'sum',toFixed:2}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 650
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '搭车采购',
						status: 'primary',
						code: 'hitchhiking'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [{
						treeNode:true,
						type: 'seq',
						title: '#',
						width:80
					},{
						field: 'warehouseID',
						title: '仓库ID',
						visible:false
					},{
						field: 'warehouseName',
						title: '仓库',						
					},{
						field: 'supplierID',
						title: '供应商ID',
						visible:false
					},{
						field: 'supplierName',
						title: '供应商',
			
					},{
						field: 'specCode',
						title: '商品编码',
			
					},{
						field: 'quantity',
						title: '数量',
			
					},{
						field: 'price',
						title: '单价',
			
					},{
						field: 'sum',
						title: '金额',
			
					},
					// {
					// 	title: '操作',
					// 	fixed: "right",
					// 	align: 'center',
					// 	width: 65,
					// 	slots: {
					// 		default: ({row}) => {
					// 			return [<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>]
					// 		}
					// 	}
					// }
				]
				gridOptions.formConfig = false
				// gridOptions.editRules = {
				// 	c: [{
				// 		required: true
				// 	},{
				// 		validator({cellValue,row}){
				// 			return new Promise((resolve,reject)=>{
				// 				if( true ){
				// 					reject(new Error('自定义错误'))
				// 				}else{
				// 					resolve()
				// 				}
								
				// 			})
				// 		}
				// 	}]
				// }
			},
			list() {
				let goods = this.data.map((item)=>{
					return {
						id:item.id,
						parentid:item.supplierwlnid,
						supplierID:item.supplierwlnid,
						supplierName:item.suppliername,
						warehouseID:item.warehousewlnid,
						warehouseName:item.warehousename,
						specCode:item.goodscode,
						price:item.taxprice,
						quantity:item.purchasenum,
						sum:(item.purchasenum * item.taxprice).toFixed(2),
						policytype:item.policytype,
						goodscode:item.goodscode,
						recommendlevel:item.recommendlevel,
						requirement:item.stock?item.stock:0,
						prochasestandards:item.prochasestandards
					}
				})
				let statics = this.$Lodash(goods).groupBy('supplierID').map((group, key) => ({
					id:key,
					supplierID: key,
					supplierName: group[0].supplierName,
					warehouseID: group[0].warehouseID,
					warehouseName: group[0].warehouseName,
					specCode:group.length,
					quantity: this.$Lodash.sumBy(group, 'quantity'),
					sum: this.$Lodash.sumBy(group, (item)=>{
						return parseFloat(item.sum)
					}).toFixed(2),
					policytype:group[0].policytype
				})).value()		
				statics.forEach((item)=>{
					item.price = (item.sum/item.quantity).toFixed(4)
				})
				this.tabledata = goods.concat(statics)
				// console.log(goods)
				return new Promise((resolve) => {
					resolve({
						list: this.tabledata
					})
				})
			},
			hitchhiking(){
				this.$refs.hitchhikingForm.modal_show()
			},
			modal_init(){
				// let formData = JSON.parse(JSON.stringify(formjson))
				// let rule = formData.rule.rule
				// let option = formData.rule.option
				// option.el = this.$refs.logistictrace_custom_form
				// this.fApi = this.$formCreate(rule, option)
				// this.fApi.nextTick(() => {
				// 	this.regestevent(rule)
				// 	this.setFormData()		
				// })
				this.$emit('show')
			},	
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			getgrid(){
				return this.$refs.list
			},
			add(){
				this.getgrid().insert({})
			},
			delete(row){
				this.getgrid().remove(row)
			},
			submit() {
				let data = this.tabledata.filter((item)=>{
					return !item.parentid
				})				
				this.$api.stockwarning.uploadwln({data:data}).then(()=>{
					
				})
			},
			reset() {
				//this.init()
			},
			list_sum(field, data, toFixed) {
				let sum = 0
				if (this.statisticsfield) {
					if (this.sourcestatisticsdata[field]) {
						sum = this.sourcestatisticsdata[field]
					}
					return sum
				} else {
					data.forEach((item) => {
						for (let i in item) {
							if (i == field) {
								sum = sum + (isNaN(parseFloat(item[i])) ? 0 : parseFloat(item[i]))
							}
						}
					})
					return sum.toFixed(toFixed)
				}

			},
		},
		components: {
			hitchhikingForm
		}
	}
</script>